(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-custom"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrient-calculator"] && !Shopify.designMode) return;
  try {
    
var _sourceEC = 0.2;
var _targetEC = 1.4;
var _sourceL = 100;
var _targetL = 0;
var _cropType = "P";

var sourceECInput = document.getElementById('sourceEC');
var targetECInput = document.getElementById('targetEC');
var tankMixLitersInput = document.getElementById('tankMixLiters');
var cropTypeSelect = document.getElementById('cropType');

sourceECInput.addEventListener('change', calculate);
targetECInput.addEventListener('change', calculate);
tankMixLitersInput.addEventListener('change', calculate);
cropTypeSelect.addEventListener('change', calculate);

// Brand-green fill shades for the three product bars (was green/orange/gray).
var BAR_COLORS = ['#375d31', '#5a7d54', '#9bb595'];

const FACTORS = {
  Hygrotech: {
    LG: { h: 0.050, c: 0.0325, k: 0 },
    MG: { h: 0.012, c: 0.008125, k: 0 },
    C:  { h: 0.050, c: 0.050,  k: 0 },
    P:  { h: 0.050, c: 0.050,  k: 0 },
    "T0-1": { h: 0.056, c: 0.044, k: 0 },
    "T1-2": { h: 0.060, c: 0.040, k: 0 },
    "T2-3": { h: 0.052, c: 0.035, k: 0.013 },
    // Strawberries (added 2026-09-06; water culture and coco peat). Derived from
    // the "Nutrient solutions for greenhouse crops" v5 strawberry tables (Delphy
    // fertigation course): standard solution EC 1.6 / pH 5.3, K 4.8, Ca 3.6,
    // NO3 12, NH4 1 mmol/L; "Start" adjustment adds Ca (+1 mmol/L), "Fruit set"
    // adds K (+2 mmol/L) and drops NH4 (-0.5). SV (planting to first flower) is
    // the 1:1 NPK:CalNit standard (K:Ca 1.09, K:N 0.93); SF (flowering & fruiting)
    // shifts to K:Ca 1.74, K:N 1.26 with no potassium nitrate needed (the NPK
    // blend already carries the potassium). Both rows sit on the same ionic-EC
    // scale as the fruiting rows above (1.08 mS/cm per unit of target minus source).
    SV: { h: 0.050,  c: 0.050,  k: 0 },
    SF: { h: 0.0618, c: 0.0387, k: 0 }
  },
  Hydrofood: {}
};
// Hydrofood rows recalibrated 2026-07-09 against the ionic EC model (label
// analysis 6.5-4.5-24 +3Mg/6S): each crop row yields the SAME EC as its
// Hygrotech counterpart (the calibration standard). Previously these rows
// overdosed by ~10-25% (MG ~5x). Blend ratios: cucumber + pepper use the
// Hygrotech 1:1 NPK:CalNit standard, and tomato first-truss uses the
// Hygrotech 56:44 proportions (the old CalNit-heavy flip was wrong); the
// remaining rows keep Aquasol's own ratios.
// Strawberry rows (2026-09-06) match the Hygrotech SV/SF ion ratios (K:Ca 1.05 /
// 1.76, K:N 0.95 / 1.36) using Hydrofood's own label analysis, at the same EC.
FACTORS.Hydrofood =
  {
  "LG":  { "h": 0.0432, "c": 0.0378, "k": 0.0000 },
  "MG":  { "h": 0.0117, "c": 0.0081, "k": 0.0000 },
  "C":   { "h": 0.0492, "c": 0.0492, "k": 0.0000 },
  "P":   { "h": 0.0492, "c": 0.0492, "k": 0.0000 },
  "T0-1":{ "h": 0.0550, "c": 0.0432, "k": 0.0000 },
  "T1-2":{ "h": 0.0414, "c": 0.0433, "k": 0.0110 },
  "T2-3":{ "h": 0.0445, "c": 0.0417, "k": 0.0123 },
  "SV":  { "h": 0.0447, "c": 0.0538, "k": 0.0000 },
  "SF":  { "h": 0.0573, "c": 0.0413, "k": 0.0000 }
};

function calculate() {
    _sourceEC = parseFloat(sourceECInput.value);
    _targetEC = parseFloat(targetECInput.value);
    _targetL = parseFloat(tankMixLitersInput.value);
    _cropType = cropTypeSelect.value;

    if (_sourceEC >= _targetEC) {
        alert("Source EC cannot be higher than the Target.");
        return;
    }

    const BRANDS = ["Hygrotech", "Hydrofood"];
    const MAX_CAP = 100; // for progress bar scaling

    BRANDS.forEach(brand => {
        const f = FACTORS[brand][_cropType] || FACTORS[brand]["P"]; // fallback
        const gH = ((_targetEC - _sourceEC) * f.h) * 10000;
        const gC = ((_targetEC - _sourceEC) * f.c) * 10000;
        const gK = ((_targetEC - _sourceEC) * f.k) * 10000;

        const H = ((gH / 1000) * _targetL).toFixed(0);
        const C = ((gC / 1000) * _targetL).toFixed(0);
        const K = ((gK / 1000) * _targetL).toFixed(0);

        const suf = (brand === "Hydrofood") ? "_hf" : "";

        document.getElementById(`txtHydroponic${suf}`).innerHTML =
            `<b><span class='bigtext'>${H}g</span></b> (${(H/1000).toFixed(2)}Kg)`;
        document.getElementById(`txtSoluCal${suf}`).innerHTML =
            `<b><span class='bigtext'>${C}g</span></b> (${(C/1000).toFixed(2)}Kg)`;
        document.getElementById(`txtUltrasol${suf}`).innerHTML =
            `<b><span class='bigtext'>${K}g</span></b> (${(K/1000).toFixed(2)}Kg)`;

        const bars = document.querySelectorAll(brand === "Hydrofood"
                           ? '.progress-bar.hf' : '.progress-bar:not(.hf)');
        [H,C,K].forEach((val, i) => {
            const pct = Math.min((val / MAX_CAP) * 100, 100);
            bars[i].style.width = pct ? pct + '%' : '0%';
            bars[i].style.background = pct ? BAR_COLORS[i] : 'transparent';
        });
    });
}

  } catch(e) { console.error(e); }
})();
})();
